import React from 'react'
import { Updater, fromJSX, Widget, any } from 'widgets-for-react'
import { InviewProps } from '../blocksState'
import { ActualitySearchBarLayout } from './actualitySearchBarLayout'
import {
  ActualitySearchBarState
} from './actualitySearchBarState'

export type ActualitySearchBarBlock = {
  index: number
  inview?: InviewProps
  actualitySearchBarState: ActualitySearchBarState
}

export const actualitySearchBarWidget = (
  block: ActualitySearchBarBlock
): Widget<Updater<ActualitySearchBarState>> => {
  return any<Updater<ActualitySearchBarState>>([
    fromJSX(setState => (
      <ActualitySearchBarLayout
        {...block}
        query={block.actualitySearchBarState.query}
        setQuery={(newQuery: string) =>
          setState(s => ({ ...s, query: newQuery }))
        }
      />
    ))
  ])
}
